// src/utils/LegacyFlatRedirect.tsx
import React, { useEffect } from 'react';
import { useParams } from '@/utils/router';

import {
  ALL_CITIES,
  cityToSlug,
  guessTypeFromLegacyTerm,
  typeLocationPath,
  globalTypePath,
  type EventType,
  type SeoCity,
} from '@/constants/geo';

const safeDecode = (s?: string) => {
  if (!s) return '';
  try {
    return decodeURIComponent(s);
  } catch {
    return s;
  }
};

const normalizeForMatch = (s: string) =>
  s
    .normalize('NFKC')
    .replace(/\u200E|\u200F/g, '') // LRM/RLM
    .trim();

const ensureSlash = (p: string) => (p.endsWith('/') ? p : `${p}/`);

const LegacyFlatRedirect: React.FC = () => {
  const { flatSlug = '' } = useParams<{ flatSlug?: string }>();

  useEffect(() => {
    const raw = normalizeForMatch(safeDecode(flatSlug));

    const cities = ALL_CITIES as readonly SeoCity[];

    const foundCity = cities.find((city) => {
      const name = normalizeForMatch(String(city));
      const slug = normalizeForMatch(safeDecode(cityToSlug(name)));

      return (
        raw.endsWith(`-ב${slug}`) ||
        raw.endsWith(`-ב${name}`) ||
        raw.includes(`-ב${slug}`) ||
        raw.includes(`-ב${name}`)
      );
    });

    const termPart = raw.replace(/-ב.*$/,'').replace(/^\/+|\/+$/g,'');
    const guessed = guessTypeFromLegacyTerm(termPart);

    if (!guessed) {
      window.location.replace('/');
      return;
    }

    const type = guessed as EventType;

    if (foundCity) {
      const dest = ensureSlash(typeLocationPath(type, String(foundCity)));
      window.location.replace(dest);
      return;
    }

    const dest = ensureSlash(globalTypePath(type));
    window.location.replace(dest);
  }, [flatSlug]);

  return null;
};

export default LegacyFlatRedirect;
